enum AddCalendarsMenuItemId {
    LandingPage = 'LandingPage',
    AddAccount = 'AddAccount',
    EditCalendar = 'EditCalendar',
    CreateCalendar = 'CreateCalendar',
    Personal = 'Personal',
    Holidays = 'Holidays',
    BingData = 'BingData',
    ImportFromFile = 'ImportFromFile',
    ImportFromWeb = 'ImportFromWeb',
    ImportFromDirectory = 'ImportFromDirectory',
    Schools = 'Schools',
    TeamSnap = 'TeamSnap',
    Sports = 'Sports',
    TV = 'TV',
    TeamsCalendars = 'TeamsCalendars',
}

export default AddCalendarsMenuItemId;
